import { Attributes, Misc, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class InterestRate extends ModelBase {
    static typeName = "InterestRate";

    public interestRateId: number = 0;

    public interestRateTypeId: number = 0;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public effectiveDate: Date | null = null;

    @Attributes.Float(10)
    public rate: number = 0;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public lookbackDate: Date | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<InterestRate>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New interest rate";
        } else {
            return "Interest Rate";
        }
    }
}